<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a class="nav-link" v-bind:href="'#t4' + rowData.cargaId + ''" role="tab" data-toggle="tab"
            v-if="rowData.cargaDoc != null">
            <span class="nav-link-in">
              Notas fiscais
              <i class="fa fa-file-text"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-bind:href="'#t3' + rowData.cargaId + ''" role="tab" data-toggle="tab"
            v-if="rowData.cargaDoc != null">
            <span class="nav-link-in">
              CTes
              <i class="fa fa-file-text-o"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-bind:href="'#t2' + rowData.cargaId + ''" role="tab" data-toggle="tab" v-if="
            rowData.cargaSequenciaEntrega != null &&
            rowData.cargaSequenciaEntrega.length > 0
          ">
            <span class="nav-link-in">
              Roterizador
              <i class="fa fa-truck"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" v-bind:href="'#t1' + rowData.cargaId + ''" role="tab" data-toggle="tab"
            v-if="rowData.statusProcessoExpedicao.valor != 1">
            <span class="nav-link-in">
              Status integrações
              <i class="fa fa-truck"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-bind:href="'#t5' + rowData.cargaId + ''" role="tab" data-toggle="tab"
          v-if="errors.length > 0 || rowData.integracaoLog.length > 0">
            <span class="nav-link-in">
              Erros
              <i class="fa fa-times"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-bind:href="'#t6' + rowData.cargaId + ''" role="tab" data-toggle="tab"
            v-if="rowData.pessoaParceira != null">
            <span class="nav-link-in">
              Pessoa Parceira
              <i class="fa fa-truck"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-bind:href="'#t7' + rowData.cargaId + ''" role="tab" data-toggle="tab"
            v-if="rowData.statusProcessoExpedicao.valor == 3">
            <span class="nav-link-in">
              Detalhes
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-bind:href="'#t8' + rowData.cargaId + ''" role="tab" data-toggle="tab"
            v-if="rowData.statusProcessoExpedicao.valor == 3">
            <span class="nav-link-in">
              Vale pedagio
              <i class="fa fa-car"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-bind:href="'#t9' + rowData.cargaId + ''" role="tab" data-toggle="tab" v-if="
            rowData.cargaMeioTransp != null &&
            rowData.cargaMeioTransp.cargaMeioTranspAjudante.length > 0
          ">
            <span class="nav-link-in">
              Ajudantes
              <i class="fa fa-users"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div role="tabpanel" class="tab-pane fade show pt-1 border-color-detalhes-grey"
          v-bind:id="'t4' + rowData.cargaId + ''">
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">N nota</th>
                <th style="width: 5%">Série</th>
                <th style="width: 5%">Data emissão</th>
                <th style="width: 45%">Cliente</th>
                <th style="width: 5%">Peso bruto</th>
                <th style="width: 5%">Peso liquído</th>
                <th style="width: 5%">Vlr. nota</th>
                <th style="width: 5%">Volume</th>
                <th style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.cargaDoc">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ item.docFiscal.numFiscal }}
                </td>
                <td>
                  {{ item.docFiscal.serie }}
                </td>
                <td>
                  {{ formatDate(item.docFiscal.dtEmi) }}
                </td>
                <td>
                  {{ item.docFiscal.docFiscalPartesEnv.desNome }} -
                  {{ item.docFiscal.docFiscalPartesEnv.desCnpj }}
                </td>
                <td>
                  {{ formatNumber(item.docFiscal.docPesoBruto) }}
                </td>
                <td>
                  {{ formatNumber(item.docFiscal.docPesoLiquido) }}
                </td>
                <td>
                  {{ formatNumber(item.docFiscal.docFiscalVlrTotal) }}
                </td>
                <td>
                  {{ formatNumber(item.docFiscal.volume) }}
                </td>
                <td>
                  <a @click="onDetailDoc(item.cardocId)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                </td>
              </tr>
              <tr v-if="isVisibleDetailRowDoc(item.cardocId)">
                <td colspan="10">
                  <section class="tabs-section">
                    <ul class="nav nav-tabs nav-topline nav-justified" role="tablist">
                      <li class="nav-item">
                        <a class="nav-link active" v-bind:href="'#docfis1' + item.cardocId + ''" role="tab"
                          data-toggle="tab">
                          <span class="nav-link-in">
                            Itens
                            <i class="fa fa-cubes"></i>
                          </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" v-bind:href="'#docfis2' + item.cardocId + ''" role="tab" data-toggle="tab">
                          <span class="nav-link-in">
                            Volumes
                            <i class="fa fa-cube"></i>
                          </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" v-bind:href="'#docfis3' + item.cardocId + ''" role="tab" data-toggle="tab">
                          <span class="nav-link-in">
                            Partes Env.
                            <i class="fa fa-cube"></i>
                          </span>
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                        v-bind:id="'docfis1' + item.cardocId + ''">
                        <table :class="['vuetable table table-striped tbl-typical']">
                          <thead>
                            <tr>
                              <th style="width: 30%">Descrição</th>
                              <th style="width: 10%">NCM</th>
                              <th style="width: 10%">CFOP</th>
                              <th style="width: 10%">Vlr. Bruto</th>
                              <th style="width: 10%">Peso liquído</th>
                            </tr>
                          </thead>
                          <tbody v-for="item2 in item.docFiscal.docFiscalProduto">
                            <tr class="bg-gray-light" style="display: table-row">
                              <td>
                                {{ item2.descr }}
                              </td>
                              <td>
                                {{ item2.ncm }}
                              </td>
                              <td>
                                {{ item2.cfop }}
                              </td>
                              <td>
                                {{ formatNumber(item2.vlrBruto) }}
                              </td>
                              <td>
                                {{ formatNumber(item2.qtdComercial) }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"
                        v-bind:id="'docfis2' + item.cardocId + ''">
                        <table :class="['vuetable table table-striped tbl-typical']">
                          <thead>
                            <tr>
                              <th style="width: 33%">Etiqueta</th>
                              <th style="width: 33%">Peso Bruto</th>
                              <th style="width: 34%">Volume</th>
                            </tr>
                          </thead>
                          <tbody v-for="item2 in item.docFiscal.docFiscalTransporte
                            .docFiscalTransporteVolume">
                            <tr class="bg-gray-light" style="display: table-row">
                              <td>
                                {{ item2.especieVolume }}
                              </td>
                              <td>
                                {{ formatNumber(item2.pesoBruto) }}
                              </td>
                              <td>
                                {{ formatNumber(item2.qtdVolume) }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"
                        v-bind:id="'docfis3' + item.cardocId + ''">
                        <table :class="['vuetable table table-striped tbl-typical']">
                          <thead>
                            <tr>
                              <th style="width: 10%"></th>
                              <th style="width: 20%">CNPJ/CPF</th>
                              <th style="width: 20%">Nome</th>
                              <th style="width: 20%">Endereço</th>
                              <th style="width: 20%">Municipio</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="bg-gray-light" style="display: table-row">
                              <td>
                                <span class="badge badge-primary">Emitente</span>
                              </td>
                              <td>
                                <span v-if="
                                  item.docFiscal.docFiscalPartesEnv.emiCnpj !=
                                  null
                                ">{{
                                    ajustaMascara(
                                      item.docFiscal.docFiscalPartesEnv.emiCnpj
                                    )
                                  }}</span>
                                <span v-if="
                                  item.docFiscal.docFiscalPartesEnv.emiCpf !=
                                  null
                                ">{{
                                    ajustaMascara(
                                      item.docFiscal.docFiscalPartesEnv.emiCpf
                                    )
                                  }}</span>
                              </td>
                              <td>
                                {{ item.docFiscal.docFiscalPartesEnv.emiNome }}
                              </td>
                              <td>
                                {{
                                  item.docFiscal.docFiscalPartesEnv.emiEndereco
                                }}
                              </td>
                              <td>
                                {{
                                  item.docFiscal.docFiscalPartesEnv
                                    .emiNomeMunicipio
                                }}
                              </td>
                            </tr>
                          </tbody>
                          <tbody>
                            <tr class="bg-gray-light" style="display: table-row">
                              <td>
                                <span class="badge badge-warning">Destinatário</span>
                              </td>
                              <td>
                                <span v-if="
                                  item.docFiscal.docFiscalPartesEnv.desCnpj !=
                                  null
                                ">{{
                                    ajustaMascara(
                                      item.docFiscal.docFiscalPartesEnv.desCnpj
                                    )
                                  }}</span>
                                <span v-if="
                                  item.docFiscal.docFiscalPartesEnv.desCpf !=
                                  null
                                ">{{
                                    ajustaMascara(
                                      item.docFiscal.docFiscalPartesEnv.desCpf
                                    )
                                  }}</span>
                              </td>
                              <td>
                                {{ item.docFiscal.docFiscalPartesEnv.desNome }}
                              </td>
                              <td>
                                {{
                                  item.docFiscal.docFiscalPartesEnv.desEndereco
                                }}
                              </td>
                              <td>
                                {{
                                  item.docFiscal.docFiscalPartesEnv
                                    .desNomeMunicipio
                                }}
                              </td>
                            </tr>
                          </tbody>

                          <tbody>
                            <tr class="bg-gray-light" style="display: table-row">
                              <td>
                                <span class="badge badge-info">Redespacho</span>
                              </td>
                              <td>
                                <span v-if="
                                  item.docFiscal.docFiscalPartesEnv.redCnpj !=
                                  null
                                ">{{
                                    ajustaMascara(
                                      item.docFiscal.docFiscalPartesEnv.redCnpj
                                    )
                                  }}</span>
                                <span v-if="
                                  item.docFiscal.docFiscalPartesEnv.redCpf !=
                                  null
                                ">{{
                                    ajustaMascara(
                                      item.docFiscal.docFiscalPartesEnv.redCpf
                                    )
                                  }}</span>
                              </td>
                              <td>
                                <span v-if="
                                  item.docFiscal.docFiscalPartesEnv.redNome !=
                                  null
                                ">{{
                                    item.docFiscal.docFiscalPartesEnv.redNome
                                  }}</span>
                              </td>
                              <td>
                                {{
                                  item.docFiscal.docFiscalPartesEnv.redEndereco
                                }}
                              </td>
                              <td>
                                <span v-if="
                                  item.docFiscal.docFiscalPartesEnv
                                    .redNomeMunicipio != null
                                ">{{
                                    item.docFiscal.docFiscalPartesEnv
                                      .redNomeMunicipio
                                  }}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t2' + rowData.cargaId + ''" v-if="
            rowData.cargaSequenciaEntrega != null &&
            rowData.cargaSequenciaEntrega.length > 0
          ">
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%">Sequência</th>
                <th data-toggle="true" style="width: 10%">Nota fiscal</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row" v-for="item in rowData.cargaSequenciaEntrega">
                <td>
                  {{ item.sequencia }}
                </td>
                <td>
                  {{ item.docFiscalNumFiscal }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t3' + rowData.cargaId + ''">
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%">Num. fiscal</th>
                <th data-toggle="true" style="width: 90%">Série</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in rowData.cargaDoc" class="bg-gray-light" style="display: table-row">
                <td>
                  <span v-if="item.docCargaDoc != null">{{
                    item.docCargaDoc.doc.numFiscal
                    }}</span>
                </td>
                <td>
                  <span v-if="item.docCargaDoc != null">{{
                    item.docCargaDoc.doc.serie
                    }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t2' + rowData.cargaId + ''" v-if="
            rowData.cargaSequenciaEntrega != null &&
            rowData.cargaSequenciaEntrega.length > 0
          ">
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%">Sequência</th>
                <th data-toggle="true" style="width: 10%">Nota fiscal</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row" v-for="item in rowData.cargaSequenciaEntrega">
                <td>
                  {{ item.sequencia }}
                </td>
                <td>
                  {{ item.docFiscalNumFiscal }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t3' + rowData.cargaId + ''">
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%">Num. fiscal</th>
                <th data-toggle="true" style="width: 90%">Série</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in rowData.cargaDoc" class="bg-gray-light" style="display: table-row">
                <td>
                  <span v-if="item.docCargaDoc != null">{{
                    item.docCargaDoc.doc.numFiscal
                    }}</span>
                </td>
                <td>
                  <span v-if="item.docCargaDoc != null">{{
                    item.docCargaDoc.doc.serie
                    }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
          v-bind:id="'t1' + rowData.cargaId + ''">
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%">Integração</th>
                <th data-toggle="true" style="width: 60%">Descrição</th>
                <th data-toggle="true" style="width: 20%">Status</th>
                <th data-toggle="true" style="width: 10%">Ações</th>
              </tr>
            </thead>
            <tbody v-if="rowData.statusProcessoExpedicao.valor != 1">
              <tr class="bg-gray-light" style="display: table-row"
                v-for="item in rowData.statusIntegracoes.statusOpentech">
                <td>
                  <span class="badge badge-primary">Opentech</span>
                </td>
                <td>
                  {{ item.tipo }} - {{ item.descr }} - {{ item.situacao }}
                </td>
                <td>
                  <span v-if="item.status.valor == 2" class="badge badge-danger">{{ item.status.descr }}</span>
                  <span v-if="item.status.valor == 1" class="badge badge-success">{{ item.status.descr }}</span>
                </td>
                <td></td>
              </tr>
              <tr class="bg-gray-light" style="display: table-row" v-for="item in rowData.statusIntegracoes.averbacao">
                <td>
                  <span class="badge badge-primary">Averbação</span>
                </td>
                <td>DOC: {{ item.num_doc }} - {{ item.serie }}</td>
                <td>
                  <span v-if="item.status.valor == 2" class="badge badge-danger">{{ item.status.descr }}</span>
                  <span v-if="item.status.valor == 1" class="badge badge-success">{{ item.status.descr }}</span>
                </td>
                <td></td>
              </tr>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-primary">Iroute</span>
                </td>
                <td></td>
                <td>
                  <span v-if="rowData.statusIntegracoes.statusIroute.valor == 3" class="badge badge-success">{{
                    rowData.statusIntegracoes.statusIroute.descr }},
                    RoutingId:
                    {{ rowData.statusIntegracoes.irouteRoutingId }}</span>
                  <span v-if="rowData.statusIntegracoes.statusIroute.valor == 2" class="badge badge-danger">{{
                    rowData.statusIntegracoes.statusIroute.descr }},
                    RoutingId:
                    {{ rowData.statusIntegracoes.irouteRoutingId }}</span>
                  <span v-if="rowData.statusIntegracoes.statusIroute.valor == 1" class="badge badge-warning">{{
                    rowData.statusIntegracoes.statusIroute.descr }},
                    RoutingId:
                    {{ rowData.statusIntegracoes.irouteRoutingId }}</span>
                </td>
                <td></td>
              </tr>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-primary">Target Roteiro</span>
                </td>
                <td></td>
                <td>
                  <span v-if="
                    rowData.statusIntegracoes.statusTargetRoteiro.status
                      .valor == 2
                  " class="badge badge-danger">{{
                      rowData.statusIntegracoes.statusTargetRoteiro.status.descr
                    }}</span>
                  <span v-if="
                    rowData.statusIntegracoes.statusTargetRoteiro.status
                      .valor == 1
                  " class="badge badge-success">{{
                      rowData.statusIntegracoes.statusTargetRoteiro.status.descr
                    }}</span>
                </td>
                <td></td>
              </tr>
              <template v-if="rowData.statusIntegracoes && rowData.statusIntegracoes.hybrid">
                <template v-if="rowData.statusIntegracoes.hybrid.cte && rowData.statusIntegracoes.hybrid.rps">
                  <template v-if="rowData.statusIntegracoes.hybrid.cte.length === 0 && rowData.statusIntegracoes.hybrid.rps.length === 0">
                    <tr class="bg-gray-light" style="display: table-row">
                      <td>
                        <span class="badge badge-primary">CTE Interno</span>
                      </td>
                      <td>
                        <span :class="getBadgeClassExpedicao(-2)">
                          Carga não possui CTE Receita
                        </span>
                      </td>
                      <td>
                        <span :class="getBadgeClassExpedicao(-2)">
                          Carga não possui CTE Receita
                        </span>
                      </td>
                      <td></td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr v-for="(item, index) in rowData.statusIntegracoes.hybrid.cte" :key="index" class="bg-gray-light"
                      style="display: table-row">
                      <td>
                        <span class="badge badge-primary">CTE Receita</span>
                      </td>
                      <td>
                        Nota: {{ item.num_fiscal_nota }} - {{ item.serie_nota}}, Doc: {{ item.num_fiscal_doc }} - {{ item.serie_doc }}
                      </td>
                      <td>
                        <span :class="getBadgeClassStatusSefaz(item.status.valor)">
                          {{ item.status.descr }}
                          <i class="fa fa-question-circle-o fa-lg" v-b-tooltip.hover.top="item.status.motivo"></i>
                        </span>
                      </td>
                      <td></td>
                    </tr>
                    <tr v-for="(item, index) in rowData.statusIntegracoes.hybrid.rps" :key="index" class="bg-gray-light"
                      style="display: table-row">
                      <td>
                        <span class="badge badge-primary">RPS Receita</span>
                      </td>
                      <td>
                        Nota: {{ item.num_fiscal_nota }} - {{ item.serie_nota }}, Doc: {{ item.num_fiscal_doc }} - {{ item.serie_doc }}
                      </td>
                      <td>
                        <span :class="getBadgeClassStatusRps(item.status.valor)">
                          {{ item.status.descr }}
                          <i class="fa fa-question-circle-o fa-lg" v-b-tooltip.hover.top="item.status.motivo"></i>
                        </span>
                      </td>
                      <td></td>
                    </tr>
                  </template>
                </template>
                <template v-else>
                  <tr class="bg-gray-light" style="display: table-row">
                    <td>
                      <span class="badge badge-primary">CTE Receita</span>
                    </td>
                    <td>{{ rowData.statusIntegracoes.hybrid.descr }}</td>
                    <td>
                      <span :class="getBadgeClassStatusSefaz(rowData.statusIntegracoes.hybrid.valor)">
                        {{ rowData.statusIntegracoes.hybrid.descr }}
                      </span>
                    </td>
                    <td></td>
                  </tr>
                </template>
              </template>
              <template v-else>
                <tr class="bg-gray-light" style="display: table-row">
                  <td>
                    <span class="badge badge-primary">CTE Receita</span>
                  </td>
                  <td colspan="3">
                    Nenhuma integração encontrada.
                  </td>
                </tr>
              </template>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-primary">Carregamento Despesa</span>
                </td>
                <td></td>
                <td>
                  <span v-if="
                    rowData.statusIntegracoes.statusCarregamentoDespesa.status
                      .valor == 2
                  " class="badge badge-danger">{{
                      rowData.statusIntegracoes.statusCarregamentoDespesa.status
                        .descr
                    }}</span>
                  <span v-if="
                    rowData.statusIntegracoes.statusCarregamentoDespesa.status
                      .valor == 1
                  " class="badge badge-success">{{
                      rowData.statusIntegracoes.statusCarregamentoDespesa.status
                        .descr
                    }}</span>
                </td>
                <td></td>
              </tr>
              <template v-if="rowData.statusIntegracoes && rowData.statusIntegracoes.nstech">
                <template v-if="Array.isArray(rowData.statusIntegracoes.nstech)">
                  <template v-if="rowData.statusIntegracoes.nstech.length === 0">
                    <tr class="bg-gray-light" style="display: table-row">
                      <td>
                        <span class="badge badge-primary">NSTech</span>
                      </td>
                      <td>
                        <span :class="getBadgeClassExpedicao(-2)">
                          Carga não possui integração na NSTech
                        </span>
                      </td>
                      <td>
                        <span :class="getBadgeClassExpedicao(-2)">
                          Carga não possui integração na NSTech
                        </span>
                      </td>
                      <td></td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr v-for="(item, index) in rowData.statusIntegracoes.nstech" :key="index" class="bg-gray-light"
                      style="display: table-row">
                      <td>
                        <span class="badge badge-primary">NSTech</span>
                      </td>
                      <td>
                        Nota: {{ item.num_doc }} - {{ item.serie }}
                      </td>
                      <td>
                        <span :class="getBadgeClassIntegracao(item.status.valor)">
                          {{ item.status.descr }}
                        </span>
                      </td>
                      <td>
                        <NstechNotaRecusa
                          :item="item"
                          :carga-id="rowData.cargaId"
                          :pode-reenviar="getPermission('expedicao.store')"
                          :reenviando="!!reenviandoNotas[`${rowData.cargaId}-${item.docfis_id}`]"
                          @reenviar="onReenviarNotaNstech(rowData, $event)"
                        />
                      </td>
                    </tr>
                  </template>
                </template>
                <template v-else>
                  <tr class="bg-gray-light" style="display: table-row">
                    <td>
                      <span class="badge badge-primary">NSTech</span>
                    </td>
                    <td>{{ rowData.statusIntegracoes.nstech.descr }}</td>
                    <td>
                      <span :class="getBadgeClassExpedicao(rowData.statusIntegracoes.nstech.valor)">
                        {{ rowData.statusIntegracoes.nstech.descr }}
                      </span>
                    </td>
                    <td></td>
                  </tr>
                </template>
              </template>
              <template v-else>
                <tr class="bg-gray-light" style="display: table-row">
                  <td>
                    <span class="badge badge-primary">NSTech</span>
                  </td>
                  <td colspan="3">
                    Nenhuma integração encontrada.
                  </td>
                </tr>
              </template>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-primary">Target Ciot</span>
                </td>
                <td></td>
                <td>
                  <span
                    v-if="
                      rowData.statusIntegracoes.statusTargetCiot &&
                      rowData.statusIntegracoes.statusTargetCiot.status.valor == 2
                    "
                    class="badge badge-danger"
                    >{{
                      rowData.statusIntegracoes.statusTargetCiot.status.descr
                    }}</span
                  >
                  <span
                    v-else-if="
                      rowData.statusIntegracoes.statusTargetCiot &&
                      rowData.statusIntegracoes.statusTargetCiot.status.valor == 3
                    "
                    class="badge badge-warning"
                    >{{
                      rowData.statusIntegracoes.statusTargetCiot.status.descr
                    }}</span
                  >
                  <span
                    v-else-if="rowData.statusIntegracoes.statusTargetCiot"
                    class="badge badge-success"
                    >{{
                      rowData.statusIntegracoes.statusTargetCiot.status.descr
                    }}</span
                  >
                </td>
                <td>
                  <a
                    @click="onCancelaCiot(rowData.cargaId, 5, rowData)"
                    v-if="canShowCancelCiotButton(rowData)"
                    v-b-tooltip
                    :title="getCancelCiotTitle(rowData)"
                    ><i class="fa fa-times-circle"></i
                  ></a>
                </td>
              </tr>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-primary">Target Pedagio</span>
                </td>
                <td></td>
                <td>
                  <span v-if="
                    rowData.statusIntegracoes.statusTargetPedagio.status
                      .valor == 2
                  " class="badge badge-danger">{{
                      rowData.statusIntegracoes.statusTargetPedagio.status.descr
                    }}</span>
                  <span v-if="
                    rowData.statusIntegracoes.statusTargetPedagio.status
                      .valor == 1
                  " class="badge badge-success">{{
                      rowData.statusIntegracoes.statusTargetPedagio.status.descr
                    }}</span>
                </td>
                <td></td>
              </tr>
              <tr class="bg-gray-light" style="display: table-row"
                v-for="item in rowData.statusIntegracoes.statusTracking">
                <td>
                  <span class="badge badge-primary">Tracking</span>
                </td>
                <td>Nota: {{ item.num_docfis }}<template v-if="item.serie"> - {{ item.serie }}</template></td>
                <td>
                  <TrackingXmlCteIndisponivel v-if="isXmlCteIndisponivel(item)" :item="item"
                    :carga-id="rowData.cargaId" @abrir-chamado="onAbrirChamadoXmlCte" />
                  <template v-else>
                    <span :class="getBadgeClassDesfecho(item)" v-b-tooltip :title="getTextoDesfecho(item)">{{ getTextoDesfecho(item) }}</span>
                    <small v-if="item.motivo_detalhe" class="d-block" :class="getClasseDetalheDesfecho(item)"
                      v-b-tooltip :title="item.motivo_detalhe">{{ item.motivo_detalhe }}</small>
                  </template>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t5' + rowData.cargaId + ''" v-if="errors.length > 0 || rowData.integracaoLog.length > 0">
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">Entidade</th>
                <th data-toggle="true" style="width: 80%">Descrição</th>
                <th data-toggle="true" style="width: 3%">Qtde</th>
                <th data-toggle="true" style="width: 10%">
                  Data Primeira e Ultima Ocorrencia
                </th>
              </tr>
            </thead>
            <tbody v-if="errors.length > 0" v-for="item in errors">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-primary" v-b-tooltip.hover.top="item.id">{{ item.entidade }}</span>
                </td>
                <td>
                  {{ item.descr }}
                </td>
                <td>
                  {{ item.qtde }}
                </td>
                <td>
                  {{ formatDateHora(item.dtPrimeiraOcorrencia) }}<br />
                  {{ formatDateHora(item.dtUltimaOcorrencia) }}
                </td>
              </tr>
            </tbody>
            <tbody v-for="item2 in rowData.integracaoLog">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-primary" v-if="item2.integracaoDescr != null">{{ item2.integracaoDescr
                    }}</span>
                </td>
                <td>
                  {{ item2.descr }}
                </td>
                <td>
                  {{ item2.qtde }}
                </td>
                <td>
                  {{ formatDateHora(item2.dtPrimeiraOcorrencia) }}<br />
                  {{ formatDateHora(item2.dtUltimaOcorrencia) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t6' + rowData.cargaId + ''" v-if="rowData.pessoaParceira != null">
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 20%">Unidade Parceira</th>
                <th data-toggle="true" style="width: 20%">Razão Social</th>
                <th data-toggle="true" style="width: 20%">
                  Unidade Transporte
                </th>
                <th data-toggle="true" style="width: 20%">Motorista</th>
                <th data-toggle="true" style="width: 20%">Placa Primária</th>
              </tr>
            </thead>
            <tbody v-if="rowData.pessoaParceira != null">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.pessoaParceira.descr }}
                </td>
                <td>
                  {{ rowData.pessoaParceira.pessoa.pessoaJuridica.razaoSocial }}
                </td>
                <td>
                  {{ rowData.cargaMeioTransp.paramTipoRodado.descr }}
                </td>
                <td>
                  <span v-if="rowData.cargaMeioTransp.nomeMotorista != null">
                    {{ rowData.cargaMeioTransp.nomeMotorista }}
                  </span>
                  <span v-if="rowData.cargaMeioTransp.nomeMotoristaJuridica != null">
                    {{ rowData.cargaMeioTransp.nomeMotoristaJuridica }}
                  </span>
                </td>
                <td>
                  {{ rowData.cargaMeioTransp.placa }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t7' + rowData.cargaId + ''">
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%">Num. MDFE</th>
                <th data-toggle="true" style="width: 10%">Num. Romaneio</th>
                <th data-toggle="true" style="width: 10%">Valor Avulso</th>
                <th data-toggle="true" style="width: 10%">Usuário Despesa</th>
                <th data-toggle="true" style="width: 60%">
                  Observação Despesa
                </th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.manifestos">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span v-if="
                    rowData.statusProcessoExpedicao.valor == 3 
                    && rowData.manifestos.length > 0
                  ">{{ item.numFiscal }}</span>
                </td>
                <td>
                  <span v-if="
                    rowData.tpOperacaoPrincipal == 3 &&
                    rowData.manifestos.length == 0 &&
                    rowData.statusProcessoExpedicao.valor == 3
                  ">{{ rowData.numCarga }}</span>
                </td>
                <td>
                  <span v-if="rowData.vlrDespesaAvulso != null">{{
                    formatNumber(rowData.vlrDespesaAvulso)
                    }}</span>
                </td>
                <td>
                  <span v-if="rowData.usuarioIdDespesa != null">{{
                    rowData.usuarioIdDespesa.email
                    }}</span>
                </td>
                <td>
                  <span v-if="rowData.obsDespesa != null">{{
                    rowData.obsDespesa
                    }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t8' + rowData.cargaId + ''">
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 20%">Cod. Vale Pedagio</th>
                <th data-toggle="true" style="width: 20%">
                  Valor Vale Pedagio
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span v-if="
                    rowData.cargaValePedagio != null &&
                    rowData.cargaValePedagio.cdValePedagio != 0
                  ">{{ rowData.cargaValePedagio.cdValePedagio }}</span>
                  <span v-if="
                    rowData.cargaValePedagio == null ||
                    rowData.cargaValePedagio.cdValePedagio == 0
                  ">Sem dados Registrados</span>
                </td>
                <td>
                  <span v-if="
                    rowData.cargaValePedagio != null &&
                    rowData.cargaValePedagio.vlrValePedagio != 0
                  ">{{
                      formatNumber(rowData.cargaValePedagio.vlrValePedagio)
                    }}</span>
                  <span v-if="
                    rowData.cargaValePedagio == null ||
                    rowData.cargaValePedagio.vlrValePedagio == 0
                  ">Sem dados Registrados</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade show pt-1 border-color-detalhes-grey"
          v-bind:id="'t9' + rowData.cargaId + ''">
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Nome</th>
                <th style="width: 5%">Cpf</th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.cargaMeioTransp.cargaMeioTranspAjudante">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ item.pessoa.pessoaFisica.nome }}
                </td>
                <td>
                  {{ ajustaMascara(item.pessoa.pessoaFisica.cpf) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
      <MontagemCargaPartesEnvForm ref="montagemcargapartesenv">
      </MontagemCargaPartesEnvForm>
    </div>
  </div>
</template>
<script>
import accounting from "accounting";
import moment from "moment";
import MontagemCargaPartesEnvForm from "./MontagemCargaPartesEnvForm";
import TrackingXmlCteIndisponivel from "../components/TrackingXmlCteIndisponivel";
import NstechNotaRecusa from "../components/NstechNotaRecusa";
import { expedicaoEndpoints } from "../services/expedicaoEndpoints";
import { algumReenvioEmAndamento } from "../utils/nstechNotaEstado";
import {
  REENVIO_FALHA_MENSAGEM,
  REENVIO_FALHA_TITULO,
  REENVIO_SUCESSO_MENSAGEM,
  REENVIO_SUCESSO_TITULO,
} from "../constants/nstechNotaCopy";
import {
  COPIA_FALHA_MENSAGEM,
  COPIA_FALHA_TITULO,
  COPIA_SUCESSO_MENSAGEM,
  COPIA_SUCESSO_TITULO,
} from "../constants/ocorrenciaIntegracaoCopy";
import { copiarParaAreaDeTransferencia } from "../utils/copiarParaAreaDeTransferencia";
import {
  showCiotIntegrationButton as showCiotIntegrationButtonFn
} from "../utils/expedicaoRowVisibility";
import {
  isXmlCteIndisponivel as isXmlCteIndisponivelFn,
  textoParaChamado as textoParaChamadoXmlCteFn,
} from "../utils/xmlCteIndisponivel";

export default {
  components: {
    MontagemCargaPartesEnvForm,
    TrackingXmlCteIndisponivel,
    NstechNotaRecusa,
  },
  data() {
    return {
      peso_bruto: "",
      visibleDetailRowsDoc: [],
      watcherPollingTimer: null,
      watcherStatus: {
        watcher_ativo: false,
        has_pending_events: false,
        open_events_count: 0,
      },
      watcherEvents: [],
      watcherNotifiedEventIds: [],
      watcherFloatingPosition: {
        left: 0,
        top: 88,
      },
      watcherDragOffset: {
        x: 0,
        y: 0,
      },
      watcherDragging: false,
      watcherMovedDuringDrag: false,
      helpForm: new Form({ statusRecord: [], params: [] }),
      watcherForm: new Form({}),
      form: new Form({ carga_id: "", tipo: "" }),
      /** Notas com reenvio em curso, chave `${cargaId}-${docfisId}` (bloqueia clique duplo). */
      reenviandoNotas: {},
      /** Atualização do painel enquanto há reenvio de nota em voo (o painel não se atualiza sozinho). */
      reenvioNstechTimer: null,
      reenvioNstechTentativas: 0,
      integracaoMapping: {
        "-3": { class: "badge badge-success", label: "Nota não enviada, pois não exige CTE" },
        "-2": { class: "badge badge-danger", label: "Sem integração" },
        "-1": { class: "badge badge-success", label: "Ok, transp não exige NSTech" },
        "0": { class: "badge badge-warning", label: "Aguardando Processar" },
        "1": { class: "badge badge-warning", label: "Nota Enviada Com Sucesso" },
        "2": { class: "badge badge-danger", label: "Erro Ao Enviar Nota" },
        "3": { class: "badge badge-warning", label: "Aguardando CTE" },
        "4": { class: "badge badge-success", label: "CTE Gerado Com Sucesso" },
        "5": { class: "badge badge-danger", label: "Erro Ao Gerar CTE" },
        "6": { class: "badge badge-warning", label: "Aguardando Manifesto" },
        "7": { class: "badge badge-success", label: "Manifesto Gerado Com Sucesso" },
        "8": { class: "badge badge-danger", label: "Erro Ao Gerar Manifesto" },
        "9": { class: "badge badge-warning", label: "Cancelando Carga" },
        "10": { class: "badge badge-success", label: "Carga Cancelada Com Sucesso" },
        "11": { class: "badge badge-danger", label: "Erro Ao Cancelar Carga" },
        "12": { class: "badge badge-success", label: "Carga integrada" },
      },
      expedicaoMapping: {
        "-2": { class: "badge badge-danger", label: "Sem integração" },
        "-1": { class: "badge badge-success", label: "Ok, transp não exige NSTech" },
        "1": { class: "badge badge-danger", label: "Sem integração" },
        "2": { class: "badge badge-warning", label: "Pendente" },
        "3": { class: "badge badge-success", label: "Concluído" },
        "4": { class: "badge badge-danger", label: "Com erro" },
        "5": { class: "badge badge-warning", label: "Em cancelamento" },
        "6": { class: "badge badge-success", label: "Cancelado" },
        "7": { class: "badge badge-danger", label: "Cancelado com erro" },
        "8": { class: "badge badge-success", label: "Não exige CTE" },
      },
      statusSefazMapping: {
        "-2": { class: "badge badge-danger", label: "Sem integração" },
        "-1": { class: "badge badge-success", label: "Não exige criar CTE receita" },

        "1": { class: "badge badge-danger", label: "Pendente" },
        "2": { class: "badge badge-warning", label: "Enviado SEFAZ" },
        "3": { class: "badge badge-warning", label: "Aguardando resposta" },
        "4": { class: "badge badge-success", label: "Autorizado" },
        "5": { class: "badge badge-danger", label: "Rejeitado" },
        "6": { class: "badge badge-danger", label: "Denegado" },
        "7": { class: "badge badge-danger", label: "Cancelado" },
        "8": { class: "badge badge-danger", label: "Inutilizado" },
        "9": { class: "badge badge-danger", label: "Erro" },
      },
      statusRpsMapping: {
        "-2": { class: "badge badge-danger", label: "Sem integração" },
        "-1": { class: "badge badge-success", label: "Não exige criar RPS receita" },

        "1": { class: "badge badge-success", label: "Normal" },
        "2": { class: "badge badge-danger", label: "Cancelado" },
      },
      /*
       * Só a classe CSS — diferente dos mapas irmãos, não há label fixo: o texto do
       * badge vem de `motivo`/`status.descr` (RN-03). O literal de erro é `falhou`.
       * O mapa não é exaustivo de propósito: cases novos de ClasseDesfechoEnum entram
       * por PR no backend e caem no fallback legado de getBadgeClassDesfecho.
       */
      classeDesfechoMapping: {
        ok: "badge badge-success",
        aguardando: "badge badge-warning",
        nao_se_aplica: "badge badge-secondary",
        falhou: "badge badge-danger",
      },
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },

  computed: {
    showFloatingWatcher() {
      return this.watcherStatus.watcher_ativo || this.watcherStatus.has_pending_events;
    },
    watcherFloatingStyle() {
      return {
        left: `${this.watcherFloatingPosition.left}px`,
        top: `${this.watcherFloatingPosition.top}px`,
      };
    },
    /** Alguma nota NSTech desta carga com job de reenvio em voo (`reenvio_em_andamento`). */
    temReenvioNstechEmAndamento() {
      const integracoes = this.rowData && this.rowData.statusIntegracoes;

      return algumReenvioEmAndamento(integracoes ? integracoes.nstech : null);
    },
    errors() {
      if (this.rowData.cargaLog == null && this.rowData.docFiscalLog == null) {
        return [];
      }
      let concatLogs = this.rowData.cargaLog.concat(this.rowData.docFiscalLog);

      let mergedLogs = concatLogs.map(function (log) {
        return {
          id: log.carlogId ? log.carlogId : log.docfislogId,
          ...log
        }
      }).sort(function (a, b) {
        return (new Date(b.dtUltimaOcorrencia).getTime()) - (new Date(a.dtUltimaOcorrencia).getTime());
      });

      return mergedLogs;
    },
  },
  watch: {
    temReenvioNstechEmAndamento: {
      immediate: true,
      handler(ativo) {
        if (ativo) {
          this.iniciaAtualizacaoDoReenvioNstech();
        } else {
          this.paraAtualizacaoDoReenvioNstech();
        }
      },
    },
  },
  mounted() {
  },
  beforeDestroy() {
    this.paraAtualizacaoDoReenvioNstech();
  },
  methods: {
    getWatcherFloatingSize() {
      return {
        width: 320,
        height: 72,
      };
    },
    setWatcherInitialPosition() {
      const { width } = this.getWatcherFloatingSize();
      this.watcherFloatingPosition.left = Math.max(window.innerWidth - width - 24, 8);
      this.watcherFloatingPosition.top = 88;
    },
    ensureWatcherFloatingPosition() {
      const { width, height } = this.getWatcherFloatingSize();
      const maxLeft = Math.max(window.innerWidth - width, 8);
      const maxTop = Math.max(window.innerHeight - height, 8);
      this.watcherFloatingPosition.left = Math.min(
        Math.max(this.watcherFloatingPosition.left, 8),
        maxLeft
      );
      this.watcherFloatingPosition.top = Math.min(
        Math.max(this.watcherFloatingPosition.top, 8),
        maxTop
      );
    },
    getWatcherPointer(event) {
      if (event.touches && event.touches.length > 0) {
        return {
          x: event.touches[0].clientX,
          y: event.touches[0].clientY,
        };
      }

      if (event.changedTouches && event.changedTouches.length > 0) {
        return {
          x: event.changedTouches[0].clientX,
          y: event.changedTouches[0].clientY,
        };
      }

      if (typeof event.clientX === "number" && typeof event.clientY === "number") {
        return {
          x: event.clientX,
          y: event.clientY,
        };
      }

      return null;
    },
    startWatcherDrag(event) {
      const pointer = this.getWatcherPointer(event);
      if (!pointer) {
        return;
      }

      this.ensureWatcherFloatingPosition();
      this.watcherDragging = true;
      this.watcherMovedDuringDrag = false;
      this.watcherDragOffset = {
        x: pointer.x - this.watcherFloatingPosition.left,
        y: pointer.y - this.watcherFloatingPosition.top,
      };
    },
    onWatcherDrag(event) {
      if (!this.watcherDragging) {
        return;
      }

      if (event.cancelable) {
        event.preventDefault();
      }

      const pointer = this.getWatcherPointer(event);
      if (!pointer) {
        return;
      }

      const { width: floatingTabWidth, height: floatingTabHeight } = this.getWatcherFloatingSize();
      const nextLeft = pointer.x - this.watcherDragOffset.x;
      const nextTop = pointer.y - this.watcherDragOffset.y;
      const maxLeft = Math.max(window.innerWidth - floatingTabWidth, 8);
      const maxTop = Math.max(window.innerHeight - floatingTabHeight, 8);

      this.watcherFloatingPosition.left = Math.min(Math.max(nextLeft, 8), maxLeft);
      this.watcherFloatingPosition.top = Math.min(Math.max(nextTop, 8), maxTop);
      this.watcherMovedDuringDrag = true;
    },
    stopWatcherDrag() {
      this.watcherDragging = false;
    },
    onWatcherTabClick() {
      if (this.watcherMovedDuringDrag) {
        this.watcherMovedDuringDrag = false;
        return;
      }

      this.openWatcherPendingEvents();
    },
    startWatcherPolling() {
      this.loadWatcherStatusAndEvents();
      this.stopWatcherPolling();
      this.watcherPollingTimer = setInterval(() => {
        this.loadWatcherStatusAndEvents();
      }, 15000);
    },
    stopWatcherPolling() {
      if (this.watcherPollingTimer) {
        clearInterval(this.watcherPollingTimer);
        this.watcherPollingTimer = null;
      }
    },
    async loadWatcherStatusAndEvents() {
      if (!this.rowData || !this.rowData.cargaId) {
        return;
      }

      try {
        const statusResponse = await this.watcherForm.get(
          `/api/watcher/carga/${this.rowData.cargaId}/status`
        );
        const statusData =
          statusResponse &&
          statusResponse.data;
        this.watcherStatus = statusData || this.watcherStatus;

        if (this.watcherStatus.has_pending_events) {
          const eventsResponse = await this.watcherForm.get(
            `/api/watcher/carga/${this.rowData.cargaId}/eventos?nao_lidos=1`
          );
          const eventsData =
            eventsResponse &&
            eventsResponse.data;
          this.watcherEvents = eventsData || [];
          this.notifyFirstUnreadWatcherEvent();
        }
      } catch (error) {
        // Não interrompe a tela de expedição se o watcher falhar momentaneamente.
      }
    },
    notifyFirstUnreadWatcherEvent() {
      const firstUnread = this.watcherEvents.find(
        (event) => !this.watcherNotifiedEventIds.includes(event.watchevt_id)
      );

      if (!firstUnread) {
        return;
      }

      this.watcherNotifiedEventIds.push(firstUnread.watchevt_id);

      const payload = firstUnread.payload || {};
      const nf = payload.num_fiscal || "N/A";
      const chave = payload.chave || "N/A";

      this.$Simplert.open({
        title: "Atenção - Nota Cancelada",
        message: `A nota ${nf} da chave ${chave} foi detectada como cancelada.`,
        customConfirmBtnText: "Marcar como lido",
        customCloseBtnText: "Fechar",
        type: "warning",
        useConfirmBtn: true,
        onConfirm: () => this.ackWatcherEvent(firstUnread.watchevt_id),
      });
    },
    async ackWatcherEvent(eventId) {
      try {
        await this.watcherForm.post(
          `/api/watcher/carga/${this.rowData.cargaId}/ack-evento/${eventId}`
        );
        this.loadWatcherStatusAndEvents();
      } catch (error) {
        // Falha de ACK não deve quebrar fluxo da tela.
      }
    },
    openWatcherPendingEvents() {
      if (!this.watcherEvents.length) {
        this.$Simplert.open({
          title: "Watcher",
          message: "Nenhum evento pendente no momento.",
          type: "info",
        });
        return;
      }

      const firstEvent = this.watcherEvents[0];
      const payload = firstEvent.payload || {};
      this.$Simplert.open({
        title: "Watcher - Evento Pendente",
        message: `Nota: ${payload.num_fiscal || "N/A"} | Chave: ${payload.chave || "N/A"}`,
        customConfirmBtnText: "Marcar como lido",
        customCloseBtnText: "Fechar",
        type: "warning",
        useConfirmBtn: true,
        onConfirm: () => this.ackWatcherEvent(firstEvent.watchevt_id),
      });
    },
    onDetailDoc(tabfrerot_id) {
      this.toggleDetailRowDoc(tabfrerot_id);
    },
    isVisibleDetailRowDoc(rowId) {
      return this.visibleDetailRowsDoc.indexOf(rowId) >= 0;
    },
    showDetailRowDoc(rowId) {
      if (!this.isVisibleDetailRowDoc(rowId)) {
        this.visibleDetailRowsDoc.push(rowId);
      }
    },
    hideDetailRowDoc(rowId) {
      if (this.isVisibleDetailRowDoc(rowId)) {
        this.visibleDetailRowsDoc.splice(
          this.visibleDetailRowsDoc.indexOf(rowId),
          1
        );
      }
    },
    toggleDetailRowDoc(rowId) {
      if (this.isVisibleDetailRowDoc(rowId)) {
        this.hideDetailRowDoc(rowId);
      } else {
        this.showDetailRowDoc(rowId);
      }
    },
    ajustaMascara(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
            /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
            "$1.$2.$3/$4-$5"
          );
        }
      }
    },
    onCancelaCiot(carga_id, tipo, rowData = this.rowData) {
      if (!this.canShowCancelCiotButton(rowData)) {
        return;
      }

      const ciotNumber = this.getCiotNumber(rowData);
      const message = ciotNumber !== "não informado"
        ? `Deseja cancelar o CIOT - ${ciotNumber}?`
        : "Deseja anular a Operação de Transporte?";

      this.$Simplert.open({
        title: "Atenção",
        message,
        customConfirmBtnText: "Sim",
        customCloseBtnText: "Não",
        type: "warning",
        useConfirmBtn: true,
        onConfirm: () => {
          this.executeCancelCiot(carga_id, tipo);
        },
      });
    },
    executeCancelCiot(carga_id, tipo) {
      this.loading = true;
      this.isDisabled = true;
      this.form.carga_id = carga_id;
      this.form.tipo = tipo;
      this.form
        .post("/api/expedicao/integracao/manual")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
        });
      Vue.nextTick(() => {
        this.$parent.$parent.$refs.vuetable.refresh();
      });
    },
    /**
     * "Reenviar esta nota" (TMS-7222, A3): reenfileira só a nota, sem reexpedir a
     * carga. O 202 só diz que o pedido foi aceito; o resultado aparece no painel
     * quando o job processar. O 404/409/422 chega com o envelope do backend e sai
     * pelo `ReturnApi`, como no cancelamento de CIOT.
     */
    onReenviarNotaNstech(rowData, docfisId) {
      const chave = `${rowData.cargaId}-${docfisId}`;

      if (this.reenviandoNotas[chave]) {
        return;
      }

      this.$set(this.reenviandoNotas, chave, true);

      const liberar = () => this.$delete(this.reenviandoNotas, chave);

      new Form({})
        .post(expedicaoEndpoints.reenviarNotaNstech(rowData.cargaId, docfisId))
        .then((response) => {
          liberar();
          this.$snotify.success(
            (response && response.message) || REENVIO_SUCESSO_MENSAGEM,
            REENVIO_SUCESSO_TITULO
          );
          Vue.nextTick(() => {
            const host = this.$parent && this.$parent.$parent;
            const vuetable = host && host.$refs ? host.$refs.vuetable : null;

            if (vuetable && typeof vuetable.reload === "function") {
              vuetable.reload();
            }
          });
        })
        .catch((errors) => {
          liberar();

          if (errors && typeof errors === "object" && errors.tp_message !== undefined) {
            new ReturnApi(errors, this, true, null, null, false);
            return;
          }

          this.$snotify.error(REENVIO_FALHA_MENSAGEM, REENVIO_FALHA_TITULO);
        });
    },
    /**
     * Enquanto houver reenvio de nota em voo, recarrega o painel a cada 10 s para o
     * botão e o resultado acompanharem o job. Limite de 90 recargas (15 min, o TTL de
     * segurança da trava no back): se a trava ficar presa, para de insistir.
     */
    iniciaAtualizacaoDoReenvioNstech() {
      if (this.reenvioNstechTimer) {
        return;
      }

      this.reenvioNstechTentativas = 0;
      this.reenvioNstechTimer = setInterval(() => {
        this.reenvioNstechTentativas += 1;

        if (this.reenvioNstechTentativas > 90) {
          this.paraAtualizacaoDoReenvioNstech();
          return;
        }

        const host = this.$parent && this.$parent.$parent;
        const vuetable = host && host.$refs ? host.$refs.vuetable : null;

        // `reload()` e não `refresh()`: o refresh volta o operador para a página 1 a cada 10 s.
        if (vuetable && typeof vuetable.reload === "function") {
          vuetable.reload();
          // Atualização silenciosa: `loadData()` liga o overlay do host (`.loadingData`,
          // que cobre a tabela inteira); o `loadSuccess` desliga de novo ao chegar.
          host.loadingData = false;
        }
      }, 10000);
    },
    paraAtualizacaoDoReenvioNstech() {
      if (this.reenvioNstechTimer) {
        clearInterval(this.reenvioNstechTimer);
        this.reenvioNstechTimer = null;
      }
    },
    getCiotNumber(shipment) {
      const cargaCiot = shipment && shipment.cargaCiot ? shipment.cargaCiot : null;
      if (!cargaCiot) {
        return "não informado";
      }

      const ciotNumber = cargaCiot.numCiot;
      const ciotNumberText = ciotNumber != null ? String(ciotNumber).trim() : "";

      return ciotNumberText !== "" && /\d/.test(ciotNumberText)
        ? ciotNumber
        : "não informado";
    },
    getCancelCiotTitle(shipment) {
      const ciotNumber = this.getCiotNumber(shipment);
      return ciotNumber !== "não informado"
        ? "Cancelar Ciot"
        : "Anular Operação de Transporte";
    },
    onEditaPartesEnv(data) {
      this.$refs.montagemcargapartesenv.onEdit(data);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY/MM/DD").format(fmt);
    },
    formatDateHora(value, fmt = "DD/MM/YYYY HH:mm:ss") {
      return value == null
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm:ss").format(fmt);
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    getBadgeClassIntegracao: function (value) {
      return (this.integracaoMapping[value] && this.integracaoMapping[value].class) || 'badge badge-secondary';
    },
    getBadgeClassExpedicao: function (value) {
      return (this.expedicaoMapping[value] && this.expedicaoMapping[value].class) || 'badge badge-secondary';
    },

    getBadgeClassStatusSefaz: function (value) {
      return (this.statusSefazMapping[value] && this.statusSefazMapping[value].class) || 'badge badge-secondary';
    },

    getBadgeClassStatusRps: function (value) {
      return (this.statusRpsMapping[value] && this.statusRpsMapping[value].class) || 'badge badge-secondary';
    },
    /*
     * Divergência deliberada do formato dos irmãos (ADR A-01): o default não pode ser
     * 'badge badge-secondary', porque esse é o estilo legítimo de `nao_se_aplica` — uma
     * classe desconhecida ficaria idêntica a "não há o que integrar". Classe ausente ou
     * desconhecida cai no comportamento legado derivado de status.valor (RN-02).
     */
    getBadgeClassDesfecho: function (item) {
      var classe = item && item.classe;
      if (classe && this.classeDesfechoMapping[classe]) {
        return this.classeDesfechoMapping[classe];
      }
      return item && item.status && item.status.valor == 1
        ? "badge badge-success"
        : "badge badge-danger";
    },
    /* RN-03: `motivo` quando presente, senão `status.descr` — nunca os dois juntos. */
    getTextoDesfecho: function (item) {
      return (item && item.motivo) || (item && item.status && item.status.descr) || "";
    },
    /*
     * A cor do detalhe acompanha a classe (ADR C-01): text-danger fixo recriaria na
     * linha de baixo o falso alarme que esta entrega existe para eliminar.
     */
    getClasseDetalheDesfecho: function (item) {
      return item && item.classe === "falhou" ? "text-danger" : "text-muted";
    },
    isXmlCteIndisponivel: function (item) {
      return isXmlCteIndisponivelFn(item);
    },
    /*
     * "Abrir chamado" não abre chamado: não há integração com Service Desk neste
     * repositório. Copia o bloco já preenchido (carga, nota, CT-e, detalhes) e
     * avisa — mesmo contrato do TMS-8396 (`PosicaoNotaFiscalDetalhes.vue`).
     */
    onAbrirChamadoXmlCte: function (item) {
      var texto = textoParaChamadoXmlCteFn(item, this.rowData.cargaId);

      if (!texto) {
        return;
      }

      copiarParaAreaDeTransferencia(texto).then((copiou) => {
        if (copiou) {
          this.$snotify.success(COPIA_SUCESSO_MENSAGEM, COPIA_SUCESSO_TITULO);
        } else {
          this.$snotify.error(COPIA_FALHA_MENSAGEM, COPIA_FALHA_TITULO);
        }
      });
    },
    perm(key) {
      return this.getPermissionFw(key);
    },
    showCiotIntegrationButton(shipment) {
      return showCiotIntegrationButtonFn(this.perm, shipment);
    },
    canShowCancelCiotButton(shipment) {
      if (!shipment || shipment.cargaCiot == null) {
        return false;
      }

      const idOperacaoTransporte = shipment.cargaCiot.cdGestaoPagto;
      if (idOperacaoTransporte == null || String(idOperacaoTransporte).trim() === "") {
        return false;
      }

      if (shipment.manifestos == null || shipment.manifestos.length === 0) {
        return true;
      }

      const existsManifestNotCanceled = shipment.manifestos.some(manifesto => {
        const manifestoStatus = manifesto.status;
        const manifestoStatusValor = manifestoStatus && typeof manifestoStatus === "object"
            ? manifestoStatus.valor : manifestoStatus;

        const manifestoStatusNumber = Number(manifestoStatusValor);
        return manifestoStatusNumber !== 9 && manifestoStatusNumber !== 14;
      });

      return !existsManifestNotCanceled;
    },
  },
};
</script>

<style scoped>
.nav-vertical {
  position: relative;
}

.watcher-floating-tab {
  position: fixed;
  z-index: 1200;
  min-width: 250px;
  max-width: 320px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 12px;
  cursor: pointer;
  color: #ffffff;
  background: linear-gradient(135deg, #1f2937, #111827);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35);
  user-select: none;
  touch-action: none;
}

.watcher-fallback-gif {
  position: relative;
  width: 38px;
  height: 38px;
  flex-shrink: 0;
}

.watcher-detective {
  position: absolute;
  left: 0;
  top: 0;
  font-size: 26px;
  animation: watcher-bob 1.4s ease-in-out infinite;
}

.watcher-lens {
  position: absolute;
  right: 0;
  bottom: -2px;
  font-size: 18px;
  animation: watcher-scan 1.1s ease-in-out infinite;
}

.watcher-floating-text {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}

.watcher-floating-text small {
  opacity: 0.9;
}

.watcher-pending-pill {
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: #dc3545;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

@keyframes watcher-bob {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-2px);
  }
}

@keyframes watcher-scan {
  0%,
  100% {
    transform: translateX(0) rotate(0deg);
  }
  50% {
    transform: translateX(-2px) rotate(-8deg);
  }
}
</style>
